<!-- TODO:loading bar -->

<div class= "site">
  <div class="header">
    <a href="#default" class="logo floating"><img src="assets/images/logogrey.svg" alt="logo" /></a>
    <div class="header-right">
      <a routerLink="/work" routerLinkActive="active">Work</a>
      <a routerLink="/fun" routerLinkActive="active">Fun</a>
      <a routerLink="/about" routerLinkActive="active">About</a>
      <a href="assets/resume_UX2021_Aug.pdf" target="_blank">Resume</a>
    </div>
  </div>
  <main [@fadeAnimation]="getRouterOutletState(o)" class="body">
    <router-outlet #o="outlet"></router-outlet>
  </main>
  
</div>

